<template>
  <div class="pageError d-flex align-items-center justify-content-around">
    <div class="pageError-l">
      <img src="~@/assets/images/404/img.png" alt="" />
    </div>
    <div class="pageError-r">
      <img src="~@/assets/images/404/404.png" alt="" />
      <span>糟糕，页面找不到了！</span>
      <el-button icon="el-icon-back" type="primary" @click="$router.push('/')" round size="medium">返回首页</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "404",
};
</script>
<style  lang="scss" scoped>
.pageError {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  padding: 10% 0 7% 0;
  min-height: calc(100vh - 198px);
  overflow: hidden;
  box-sizing: border-box;
  .pageError-l,
  .pageError-r {
    width: 48%;
  }
  .pageError-l img {
    width: 40%;
    float: right;
    margin-right:50px;
  }
  .pageError-r {
    img {
      width: 40%;
    }
    span {
      display: block;
      line-height: 3;
      font-size: 24px;
      color: rgb(34, 34, 34);
      font-weight: 700;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/errorpage/404.vue